import React, {useEffect, useState} from 'react'
import {useProyecto} from "../../Profile.jsx";
import {useEditor} from "../../../../App.jsx";
import axios from "axios";
import {IconEdit, IconProject, IconUser} from "../../../Customiz3r/components/ToolSelectorTop/Icons.jsx";
import HoverImageIcon
    from "../../components/Editor/Editores/PresupuestoEditor/ItemPresupuestoEditor/HoverImageIcon.jsx";
import {useNavigate} from "react-router-dom";
// import PresupuestoItemCard from "./PresupuestoItemCard.jsx";
import classNames from "classnames";
import PresupuestoCard from "./PresupuestoCard.jsx";
import Cookies from "js-cookie";
import PresupuestoItemCard2 from "./PresupuestoItemCard2.jsx";
import {mdiArrowLeft} from "@mdi/js";
import DraggableBackButton from "../../components/Editor/DraggableBackButton.jsx";

const VerMiPresupuesto = () => {



    const initialState = {
        "mode": "list",
        "data": { "columns": 3 }
    };
    // Estado para el modo de vista de la lista
    const [viewMode, setViewMode] = useState(() => {
        const savedViewMode = Cookies.get('viewModeMiPresupuesto');
        return savedViewMode ? JSON.parse(savedViewMode) : initialState;
    });
    // Effect to update the cookie whenever viewMode changes
    useEffect(() => {
        Cookies.set('viewModeMiPresupuesto', JSON.stringify(viewMode), { expires: 7 }); // Save for 7 days
    }, [viewMode]);




    const [presupuesto, setPresupuesto] = useState(null);
    const {proyecto, setProyecto} = useProyecto();
    const [showItemEditor, setShowItemEditor] = useState(false); // Estado para controlar el editor de ítems
    const [selectedItemId, setSelectedItemId] = useState(null); // Para identificar el ítem a editar

    const {stateEditor, setStateEditor} = useEditor();

    useEffect(() => {

        if (proyecto){

        }else{
            setProyecto(stateEditor?.editorID);
        }
    },[proyecto] );

    console.log("ProyectoViewer", stateEditor?.editorID);

    const navigate = useNavigate(); // Initialize navigate

    useEffect(() => {
        if (stateEditor?.editorID) {
            // Cargar los datos del presupuesto
            axios.get(`/presupuestos/${stateEditor?.editorID}/`)
                .then(response => {
                    setPresupuesto(response.data);
                    setProyecto({
                        ...proyecto,
                        id: response.data.proyecto
                    });
                    console.log('Presupuesto:', response.data);
                })
                .catch(error => {
                    console.error('Error al cargar el presupuesto:', error);
                });
        }
    }, [stateEditor?.editorID]);

    const handleEdit = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: stateEditor?.editorID,
            editorType: "presupuesto_editor"
        });
    };

    const handleAddItem = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: "add",
            editorType: "item_presupuesto_editor"
        });

    };

    const handleEditItem = (itemId) => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: itemId,
            editorType: "item_presupuesto_editor"
        });
        // setProyecto(proyecto);
    };
    const handleViewItem = (itemId) => {

        //Goes to link /viewer/${itemId}
        navigate(`/viewer/${itemId}`);
    };

    const handleZoomCardThumbnail = () => {
        // Zoom into the card thumbnail
        console.log('Zoom into the card thumbnail');

    }

    const handleCloseItemEditor = () => {
        setShowItemEditor(false); // Cerrar el editor de ítems
        setSelectedItemId(null); // Resetear el ítem seleccionado
        // Aquí podrías recargar la lista de ítems si lo deseas
        // axios.get(`/presupuestos/${id}/`).then(response => setPresupuesto(response.data));
    };

    return (

        <>
            <div className="flex h-full w-full items-center justify-center">


                <div className="grid h-full w-full gap-2   grid-cols-3 grid-rows-12 rounded-lg">

                    <div
                        className="col-span-3 row-span-1 glassCard rounded-lg shadow-md flex  items-center p-3 "
                    >
                        <div className="w-full">
                            <h2 className='text-3xl'>Presupuesto</h2>
                            <div className="absolute top-0 right-0 flex space-x-3">
                                <DraggableBackButton
                                    initialPosition={{ x: 0, y: "15px" }} // Posición inicial opcional
                                    onClick={() => {
                                        setStateEditor({
                                            ...stateEditor,
                                            editorType: "mi_proyecto_viewer",
                                            editorID: proyecto.id,
                                            editor: true
                                        });
                                    }} // Función al hacer clic
                                    iconPath={mdiArrowLeft} // Ícono opcional
                                    label="Presupuestos" // Texto del botón opcional
                                />
                                {/*<button
                                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition duration-200 ease-in-out"
                                    onClick={() => {
                                        setStateEditor({
                                            ...stateEditor,
                                            editorType: "mi_proyecto_viewer",
                                            editorID: proyecto.id,
                                            editor: true
                                        });
                                    }}
                                    aria-label="Volver a presupuestos"
                                >

                                    <div className="flex items-center">
                                        <IconProject className="w-6 h-6"/>
                                        <span className="ml-2">Proyecto</span>
                                    </div>
                                </button>*/}
                            </div>
                        </div>

                    </div>

                    <div
                        className="col-span-3 row-span-2 glassCard rounded-lg shadow-md flex flex-col items-center p-3 "
                    >

                        <div className=" w-full">
                            <h2 className="text-lg font-bold w-full">Detalles del Presupuesto</h2>
                        </div>
                        <div className="flex-row h-full w-full overflow-y-auto scrollbar_mod">
                            <p><strong>Nombre Proyecto:</strong>  {proyecto?.nombre}</p>
                            <p><strong>Descripción:</strong> {presupuesto?.descripcion}</p>
                            <p><strong>Fecha de Creación:</strong> {presupuesto?.fecha_creacion}</p>
                            <p><strong>Estado:</strong> {presupuesto?.estado}</p>
                        </div>
                    </div>

                    <div className="col-span-3 row-span-8 glassCard rounded-lg shadow-md flex max-w-full">

                        <div className="w-full h-full ">


                            <div className={
                                classNames(
                                    'h-full mt-0 mr-0 w-full  overflow-y-auto scrollbar_mod',
                                    viewMode.mode === 'grid' ? `grid grid-cols-${viewMode.data.columns} gap-4` : 'flex flex-col space-y-2 p-2'
                                )
                            }>
                                {presupuesto?.items?.length > 0 ? (
                                    presupuesto?.items?.map((item, index) => (
                                        <PresupuestoItemCard2
                                            key={item.id}
                                            item={item}
                                            index={index}
                                            handleViewItem={handleViewItem}
                                            handleZoomCardThumbnail={handleZoomCardThumbnail}
                                        />
                                    ))
                                ) : (
                                    <div className="text-center p-4 text-gray-500 dark:text-gray-300">
                                        No hay elementos en el presupuesto.
                                    </div>
                                )}
                            </div>
                        </div>



                    </div>

                    {/*<div className="col-span-3 row-span-1 glassCard rounded-lg shadow-md
                        flex flex-col items-center p-2 md:p-1 lg:p-2
                        text-center md:text-left
                        align-middle
                        ">

                        <p className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 dark:text-gray-100">
                            Precio total: {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(presupuesto?.precio_total)}                        </p>
                    </div>*/}
                    <div className="col-span-3 row-span-1 glassCard rounded-lg shadow-md
                        flex items-center justify-center p-4 md:p-1 lg:p-2
                        text-center
                        ">
                        <p className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 dark:text-gray-100">
                            Precio total: {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(presupuesto?.precio_total)}
                        </p>
                    </div>

                </div>
            </div>

        </>
    );
}
export default VerMiPresupuesto
